import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { LockIcon, StoreIcon, PackageIcon, LayoutTemplateIcon, InboxIcon, LogOutIcon, ExternalLinkIcon } from 'lucide-react';
import { useContent } from '../ContentContext';
import { PartnerManager } from '../components/admin/PartnerManager';
import { ProductManager } from '../components/admin/ProductManager';
import { ContentManager } from '../components/admin/ContentManager';
import { RequestManager } from '../components/admin/RequestManager';
type Tab = 'partners' | 'sortiment' | 'startsida' | 'forfragningar';
const TABS: {
  id: Tab;
  label: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
}[] = [{
  id: 'partners',
  label: 'Partners',
  icon: StoreIcon
}, {
  id: 'sortiment',
  label: 'Sortiment',
  icon: PackageIcon
}, {
  id: 'startsida',
  label: 'Startsida',
  icon: LayoutTemplateIcon
}, {
  id: 'forfragningar',
  label: 'Förfrågningar',
  icon: InboxIcon
}];
export function Admin() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [activeTab, setActiveTab] = useState<Tab>('partners');
  const {
    businesses,
    requests
  } = useContent();
  if (!isLoggedIn) {
    return <div className="flex min-h-screen items-center justify-center bg-gray-50 px-6 py-20" data-id="element-740" data-mp="3bn3obqm2hzc4">
        <div className="w-full max-w-md rounded-3xl bg-white p-10 shadow-floating" data-id="element-741" data-mp="36o0smwrz95gt">
          <div className="mb-8 flex justify-center" data-id="element-742" data-mp="36q4wjepvm4h3">
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-black text-white" data-id="element-743" data-mp="31pz7m6azqw2p">
              <LockIcon className="h-6 w-6" data-id="element-744" data-mp="2wxfj4earmgj4" />
            </div>
          </div>
          <h1 className="text-center font-display text-3xl font-medium text-gray-900" data-id="element-745" data-mp="2rycpdq08jwqg">Logga in</h1>
          <p className="mt-2 text-center text-sm text-gray-500" data-id="element-746" data-mp="2nybzn97orz43">Adminportal för Smaken som Baken</p>

          <form className="mt-8 space-y-5" onSubmit={e => {
          e.preventDefault();
          setIsLoggedIn(true);
        }} data-id="element-747" data-mp="2iyplmxk1aeu8">
            <div data-id="element-748" data-mp="2e0ecyq5h6adl">
              <label className="mb-2 block text-xs font-bold uppercase tracking-wider text-gray-500" data-id="element-749" data-mp="2dzv6c5l9z8ev">E-postadress</label>
              <input type="email" required placeholder="admin@smakensombaken.se" className="w-full rounded-xl border border-gray-200 bg-white p-4 text-gray-900 outline-none transition-colors focus:border-black" data-id="element-750" data-mp="24dtx2n7fh81n" />
            </div>
            <div data-id="element-751" data-mp="1zehb04ods504">
              <label className="mb-2 block text-xs font-bold uppercase tracking-wider text-gray-500" data-id="element-752" data-mp="2n2ifn2ifv1a9">Lösenord</label>
              <input type="password" required placeholder="••••••••" className="w-full rounded-xl border border-gray-200 bg-white p-4 text-gray-900 outline-none transition-colors focus:border-black" data-id="element-753" data-mp="2s1l8zpp23j2e" />
            </div>
            <button type="submit" className="mt-2 w-full rounded-full bg-black py-4 text-sm font-medium text-white transition-transform hover:scale-[1.02]" data-id="element-754" data-mp="360kx8w8npvy1">
              Logga in
            </button>
          </form>
        </div>
      </div>;
  }
  const newRequests = requests.filter(r => r.status === 'ny').length;
  const totalProducts = businesses.reduce((sum, b) => sum + b.products.length, 0);
  return <div className="flex min-h-screen bg-gray-50" data-id="element-755" data-mp="194q9a7yyfcq8">
      <aside className="sticky top-28 hidden h-[calc(100vh-7rem)] w-64 shrink-0 flex-col border-r border-gray-100 bg-white p-6 md:flex" data-id="element-756" data-mp="144ltkk5vem12">
        <p className="text-xs font-bold uppercase tracking-widest text-gray-400" data-id="element-757" data-mp="ge88jdlpdnfz">Adminportal</p>

        <nav className="mt-8 space-y-1" data-id="element-758" data-mp="bgpyfjvy926e">
          {TABS.map(({
          id,
          label,
          icon: Icon
        }) => <button key={id} onClick={() => setActiveTab(id)} className={`flex w-full items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium transition-colors ${activeTab === id ? 'bg-black text-white' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-759" data-mp="pfzhqsfgccel">
              <Icon className="h-4 w-4" data-id="element-760" data-mp="2s2o7zst8y7zq" />
              {label}
              {id === 'forfragningar' && newRequests > 0 && <span className="ml-auto flex h-5 min-w-[20px] items-center justify-center rounded-full bg-gray-900 px-1.5 text-[10px] font-bold text-white" data-id="element-761" data-mp="2w51dcg4303vz">
                  {newRequests}
                </span>}
            </button>)}
        </nav>

        <div className="mt-8 rounded-2xl bg-gray-50 p-4 text-xs text-gray-500" data-id="element-762" data-mp="3b1ilyzkvz4eu">
          <p data-id="element-763" data-mp="3azfxijzdtjc8">{businesses.length} partners</p>
          <p className="mt-1" data-id="element-764" data-mp="3f1st4fkf00va">{totalProducts} produkter</p>
        </div>

        <div className="mt-auto space-y-2 pt-6" data-id="element-765" data-mp="3jtuf4t7dx5yi">
          <Link to="/" className="flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100" data-id="element-766" data-mp="3ju41m6t80uzg">
            <ExternalLinkIcon className="h-4 w-4" data-id="element-767" data-mp="3tt1svhi172m5" /> Visa sajten
          </Link>
          <button onClick={() => setIsLoggedIn(false)} className="flex w-full items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100" data-id="element-768" data-mp="2knsgapzawdf">
            <LogOutIcon className="h-4 w-4" data-id="element-769" data-mp="1i2ty8m5v47t4" /> Logga ut
          </button>
        </div>
      </aside>

      <main className="min-w-0 flex-1 p-6 md:p-10" data-id="element-770" data-mp="1d5txmqrs7x9e">
        {/* Mobile tabs */}
        <div className="mb-8 flex gap-2 overflow-x-auto md:hidden" data-id="element-771" data-mp="187iqwowsa2ve">
          {TABS.map(({
          id,
          label
        }) => <button key={id} onClick={() => setActiveTab(id)} className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${activeTab === id ? 'bg-black text-white' : 'bg-white text-gray-600'}`} data-id="element-772" data-mp="25tg54a44rm1j">
              {label}
            </button>)}
        </div>

        {activeTab === 'partners' && <PartnerManager data-id="element-773" data-mp="2ols4qp3eg97z" />}
        {activeTab === 'sortiment' && <ProductManager data-id="element-774" data-mp="2jtifzce0tf7a" />}
        {activeTab === 'startsida' && <ContentManager data-id="element-775" data-mp="2jrxndsb9o6c2" />}
        {activeTab === 'forfragningar' && <RequestManager data-id="element-776" data-mp="hxjbwz7bo39s" />}
      </main>
    </div>;
}